import './App.css';
import Home from './home/home.js'

function App() {
  return (
    <Home/>
  );
}

export default App;
